import React, { useMemo, useState } from 'react'
import { Button } from '../../../../../../../components'
import ErrorMessage from '../../../../../../../components/Form/ErrorMessage'
import { useInfinitePagination } from '../../../../../../../hooks/useInfinitePagination'
import useUrlParam from '../../../../../../../hooks/useUrlParam'
import ecbrApi from '../../../../../../../services/ecbrApi'
import { getDate } from '../../../../../../../utils/dateUtils'
import PillarCard from '../../../../../Components/PillarCard'
import { Container } from './styles'

const pagination = { page: 1, take: 10 }

const Pillars = () => {
  const [error, setError] = useState('')
  const [brandId, certificateId] = useUrlParam(
    '/user/brands/:id/certificates/:id'
  )
  const [searchParameters, _setSearchParameters] = useState({
    ...pagination
  })

  const {
    data: pillars,
    fetchNextPage,
    hasNextPage,
    isLastPage,
    isFetching,
    isLoading
  } = useInfinitePagination(
    'pillars',
    async (params) => {
      const { pageParam = searchParameters.page } = params
      return ecbrApi.pillars.getUserCertificatePillars(certificateId, {
        ...searchParameters,
        page: pageParam || searchParameters.page,
        orderBy: 'pillarId'
      })
    },
    {
      onSuccess: () => {
        setError('')
      },
      onError: () => {
        setError('Não foi possível carregar os dados')
      }
    }
  )

  const cards = useMemo(() => {
    return (
      pillars?.map((certificate) => {
        return {
          title: certificate.pillar?.name,
          name: certificate.owner?.name || '',
          data: getDate(certificate.createdAt),
          percent: certificate.answeredPercentage || 0,
          id: certificate.pillar?.id,
          questionnaireLink: `/user/brands/${brandId}/certificates/${certificateId}/questionary/${
            certificate.pillar?.id || 0
          }`
        }
      }) || []
    )
  }, [brandId, certificateId, pillars])

  return (
    <>
      <Container>
        {cards?.map?.((card) => {
          return <PillarCard card={card} key={card.id} />
        })}
        {(isFetching || isLoading) && <div>Carregando...</div>}
        {!cards?.length && !isFetching && !isLoading && (
          <div>Nenhum Pilar encontrado</div>
        )}
        {error && <ErrorMessage>{error}</ErrorMessage>}
        {hasNextPage && !isLastPage && !isFetching && (
          <Button
            type="button"
            variant="outlined"
            text="Carregar mais"
            width="200px"
            height="40px"
            onClick={fetchNextPage}
          />
        )}
      </Container>
    </>
  )
}

export default Pillars
